<template>
<div>  <b-field class="commonrules-grp" :label="`Car rental average daily cost is more than ${currencySymbol}`">
    <b-input type="number" class="cstmb-input" v-model="carDailyCost" @input="$emit('carDailyCost',carDailyCost)" />
  </b-field>
</div>
</template>
  <script>
    export default {
      name: "CarDailyCost",
      components: {},
      props:{ carCost : null},
      data() {
        return {
          carDailyCost : null
        }
      },
      computed: {
        currencySymbol() {
          return this.$store.getters['travellersAndTrips/getUserCurrencyInfo'].symbol;
        }
      },
      methods:{},
      mounted() {
        this.carDailyCost = this.carCost;
    }
    }
  </script>

  <style scoped>
  </style>